import React, {useMemo} from 'react';
import objectPath from 'object-path';
import SVG from 'react-inlinesvg';
import {useHtmlClassService} from '../../_core/MetronicLayout';
import {toAbsoluteUrl} from '../../../_helpers';

export function Brand() {
    const uiService = useHtmlClassService();

    const layoutProps = useMemo(() => {
        return {
            brandClasses: uiService.getClasses('brand', true),
            asideSelfMinimizeToggle: objectPath.get(
                uiService.config,
                'aside.self.minimize.toggle'
            ),
            headerLogo: uiService.getLogo(),
        };
    }, [uiService]);

    return (
        <>
            {/* begin::Brand */}
            <div
                className={`brand d-flex align-items-center justify-content-between px-4 ${layoutProps.brandClasses}`}
                id='kt_brand'>
                {/* begin::Logo */}
                <div className='brand-logo d-flex align-items-center'>
                    <span className='brand-text font-weight-bolder font-size-h4 text-white'>
                        An Coffee
                    </span>
                </div>
                {/* end::Logo */}

                {layoutProps.asideSelfMinimizeToggle && (
                    <>
                        {/* begin::Toggle */}
                        <button
                            className='brand-toggle btn btn-sm px-0'
                            id='kt_aside_toggle'>
							<span className='svg-icon svg-icon-xl'>
								<SVG
                                    src={toAbsoluteUrl(
                                        '/media/svg/icons/Navigation/Angle-double-left.svg'
                                    )}
                                />
							</span>
                        </button>
                        {/* end::Toolbar */}
                    </>
                )}
            </div>
            {/* end::Brand */}
        </>
    );
}
